<template>
    <div></div>
</template>

<script>


export default {
    name: "Logout",
    data () {
        return {
        
        }
    },
    async mounted() {
        this.$root.userLogout();
    },
};
</script>

<style scoped>

</style>
